import Vue from 'vue'
import Vuex from 'vuex'
import Cookies from 'js-cookie'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
    setUser(state,data){
      Cookies.set('user_id',data.user_id,{expires:7})
      Cookies.set('access_token',data.access_token,{expires:7});
    }
  },
  actions: {
  },
  modules: {
  }
})
